/* eslint-disable react-hooks/exhaustive-deps */
import { MouseEvent, useEffect, useRef, useState } from "react";
import { NotificationProvider } from "../../../contexts/notification-context";
import { useFileManagement } from "../../../services/file-management";
import { DentalTechSearchFilterPanel, TTechnicianFilterSettings } from "../../common/dental-tech-search-filter-panel";
import { Header } from "../../common/header";
import { Footer } from "../main-page/footer";
import { useTechnicians } from "../../../services/technicians";
import { TApiTechnician } from "../../../lib/types/dentalTechs";
import { InviteButton } from "../../common/invite-button";
import { getIndustryRoles } from "../../../services/generalInfo";
import { TGenericGUIDName, TGenericIdName } from "../../../lib/types/general";
import { useRouteNavigation } from "../../../lib/common/routes";
import { getCacheKillQueryString } from "../../../lib/common/api";
import { TECH_SEARCH_PAGINATION_SIZE } from "../../../lib/common/constants";
import { Pagination } from "../../common/pagination";
import { getRegions } from "../../../services/regions";
import { Spinner } from "../../common/spinner";
import { BackButton } from "../../common/backbutton";
import { LogoTech } from "../../logo";

type TDentalTechInfoProps = {
    userInfo: TApiTechnician;
    industryRoles: TGenericIdName[];
    desiredRegion: TGenericGUIDName[];
};

const currencyFormater = new Intl.NumberFormat();

export const DentalTechInfo = (props: TDentalTechInfoProps) => {
    const { userInfo, industryRoles, desiredRegion } = props;
    const { getImagePath } = useFileManagement();
    const { navigateRouteClickHandler } = useRouteNavigation();
    const [imgLogo, setImgLogo] = useState<string | null>(null);
    useEffect(() => {
        setImgLogo(getImagePath("logo", "fixed", userInfo.guid) + "?" + getCacheKillQueryString());
    }, []);

    // const imgBackground = userInfo.images?.background && getImagePath(userInfo.images?.background, "fixed", userInfo.id);
    const roleList = !userInfo.other.roles ? [] : userInfo.other.roles.map((_role) => industryRoles.find((rol) => rol.id === _role.id)?.name);

    const SkillList = () => {
        const [isExpanded, setIsExpanded] = useState<boolean>(false);

        const totalSkills = roleList.length;
        const showSkills = 3;
        const remainingSkills = totalSkills - showSkills;

        const miniList = roleList.slice(0, showSkills);
        const totalList = roleList;

        return (
            <>
                {isExpanded ? (
                    <>
                        {totalList.map((skill, index) => (
                            <small key={index} className="text-wrap text-start badge bg-white rounded-pill border border-2 border-info me-2 mb-1 text-dark">
                                {skill}
                            </small>
                        ))}
                        <button
                            className="btn btn-link text-info p-0 showLessBtn"
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsExpanded(false);
                            }}
                        >
                            show less
                        </button>
                    </>
                ) : (
                    <>
                        {miniList.map((skill, index) => (
                            <small key={index} className="text-wrap text-start badge bg-white rounded-pill border border-2 border-info me-2 mb-1 text-dark">
                                {skill}
                            </small>
                        ))}
                        {remainingSkills > 0 && (
                            <>
                                <button
                                    className="btn btn-link text-info p-0 showLessBtn"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setIsExpanded(true);
                                    }}
                                >
                                    ... and {remainingSkills} more
                                </button>
                            </>
                        )}
                    </>
                )}
            </>
        );
    };

    const goToTechClickHandler = (e: MouseEvent) => {
        navigateRouteClickHandler("dentalTechInfo", e, userInfo.id.toString(), true);
    };

    const title = `${userInfo.name} wants to connect with you.`;
    return (
        <div className="col-lg-4 col-md-6 mb-4 px-3 d-flex" key={userInfo.id}>
            <div className="card p-3 shadow rounded-3 h-100 w-100 card-tech-top border-0">
                <div
                    className="card-title row position-relative text-center text-lg-start"
                    onClick={goToTechClickHandler}
                    role="button"
                    // style={{
                    //     [imgBackground ? 'backgroundImage' : '']: `url(${imgBackground})`
                    // }}
                >
                    <div className="col-lg-4 text-center">
                        {imgLogo && (
                            <>
                                <LogoTech
                                    editable={false}
                                    userInfo={userInfo}
                                    workingState={"done"}
                                    isSomePartBeingEdited={false}
                                    extraClass="card-img-top rounded-circle shadow card-tech-top__logo border border-info border-2"
                                    setInappropriateContent={() => {}}
                                    setUnsupportedImageType={() => {}}
                                />
                            </>
                        )}
                    </div>
                    <div className="col-lg-6">
                        <h6 className={"fw-bold mt-3 mt-lg-0" + (!!userInfo.incognito ? " lab-can-not-see" : "")}>
                            {userInfo.name}
                            <br />
                        </h6>
                        {userInfo.other.desiredRegion !== undefined && (
                            <p>
                                <i className="fa-solid fa-earth-americas text-info me-2"> </i>
                                <small>
                                    {desiredRegion
                                        .filter((region) => userInfo?.other?.desiredRegion?.includes(region.guid))
                                        .map((region) => region.name)
                                        .join(", ")}
                                </small>
                            </p>
                        )}
                    </div>
                    <div className="col-lg-2"></div>
                </div>
                <div className="position-absolute top-0 end-0 m-3">
                    {userInfo.inmycontactlist && (
                        <div className="invitation-accepted rounded-3 shadow bg-info text-white" data-tooltip="In Contact" data-testid="inContact-icon">
                            <i className="fa-solid fa-user-check fa-xs"></i>
                        </div>
                    )}
                    {!userInfo.inmycontactlist && userInfo.invitationsenttome && (
                        <div className="invitation-requested rounded-3 shadow bg-warning text-white" data-tooltip={title}>
                            <i className="fa-solid fa-envelope fa-xs"></i>
                        </div>
                    )}
                    {!userInfo.inmycontactlist && userInfo.invitationsentstate === "unread" && (
                        <div className="invitation-requested rounded-3 shadow bg-white" data-tooltip="Invitation sent. Awaiting their reply.">
                            <i className="fa-solid fa-user-clock fa-xs"></i>
                        </div>
                    )}
                </div>
                <div className="card-body text-start p-0" role="button" onClick={goToTechClickHandler}>
                    <div className="row mb-3">
                        <div className="col-4 fw-bold">
                            <small>Experience</small>
                        </div>
                        <div className="col-8">
                            {!!userInfo?.other.yearsOfExperience && <small>{userInfo?.other?.yearsOfExperience} years</small>}
                            {!!!userInfo?.other.yearsOfExperience && <small className="no-data">No experience to show</small>}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-4 fw-bold">
                            <small>Desired Pay</small>
                        </div>
                        <div className="col-8">
                            {!!userInfo?.other?.desiredSalaryPerYear ? (
                                <small>
                                    $ {currencyFormater.format(Number(userInfo.other.desiredSalaryPerYear.amount ?? userInfo.other.desiredSalaryPerYear))}{" "}
                                    {userInfo.other.desiredSalaryPerYear.frequency ?? "yearly"}
                                </small>
                            ) : (
                                <small className="no-data">No pay to show</small>
                            )}
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-4 fw-bold">
                            <small>Skillset</small>
                        </div>
                        <div className="col-8 mt-lg-2">
                            <SkillList />
                        </div>
                    </div>
                </div>
                <div className="card-footer border-0 bg-transparent p-0 mt-auto">
                    {!userInfo.inmycontactlist && !userInfo.invitationsenttome && userInfo.invitationsentstate !== "accepted" && (
                        <InviteButton userToInviteId={userInfo.id} userToInviteInvitationState={userInfo.invitationsentstate} userType="tech" />
                    )}
                    {!userInfo.inmycontactlist && userInfo.invitationsenttome && (
                        <button className="btn btn-warning w-100 fw-bold" onClick={goToTechClickHandler}>
                            <small>REVIEW INVITATION</small>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export const DentalTechSearch = () => {
    const { getTechSearch, state } = useTechnicians();
    const [technicians, setTechnicians] = useState<TApiTechnician[]>([]);
    const [industryRoles, setIndustryRoles] = useState<TGenericIdName[]>([]);
    const [region, setRegion] = useState<TGenericGUIDName[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);

    const refFilter = useRef<HTMLDivElement>(null);
    const regionFilters = useRef<string[]>();
    const industryRolesFilters = useRef<number[]>();
    const nameFilter = useRef<string[]>();

    useEffect(() => {
        getIndustryRoles().then((roles) => {
            setIndustryRoles(roles);
            // refreshList();
        });
        getRegions().then((region) => {
            setRegion(region);
        });
    }, []);

    const refreshList = async (offset: number) => {
        const techs = await getTechSearch(
            {
                filterPositions: industryRolesFilters.current,
                filterRegions: regionFilters.current,
                filterName: nameFilter.current,
            },
            offset,
        );
        setTechnicians(techs.users);
        setTotalCount(techs.totalCount);
        setPageNumber(offset + 1);
    };

    const resetCallback = () => {
        regionFilters.current = undefined;
        industryRolesFilters.current = undefined;
        nameFilter.current = undefined;
        refreshList(0);
    };

    const filterCallback = async (filterSettings: TTechnicianFilterSettings) => {
        const { regions, industryRoles, names } = filterSettings;

        regionFilters.current = regions ? regions.map((o) => o.data.id) : [];
        industryRolesFilters.current = industryRoles ? industryRoles.map((o) => Number(o.data.id)) : [];
        nameFilter.current = names ? names.map((o) => o.data.name) : [];

        await refreshList(0);
    };

    return (
        <NotificationProvider>
            <Header title="" />

            <div className="container-fluid">
                <div className="container">
                    <div className="row align-items-center gx-2 py-3">
                        <div className="col-auto">
                            <BackButton />
                        </div>
                        <div className="col text-center">
                            <h2>Explore Qualified Dental Talent</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="py-3" ref={refFilter}>
                    <DentalTechSearchFilterPanel searchJustFromContactList={false} filterCallback={filterCallback} resetCallback={resetCallback} />
                </div>
            </div>
            <div className="container-fluid mt-3">
                <div className="container">
                    {state === "working" && (
                        <div className="text-center">
                            <Spinner spinnerColor="text-primary fa-xl" />
                        </div>
                    )}
                    {state === "idle" && technicians.length > 0 && (
                        <>
                            <div className="row mb-4">
                                {technicians.map((userInfo) => (
                                    <DentalTechInfo key={userInfo.id} industryRoles={industryRoles} userInfo={userInfo} desiredRegion={region} />
                                ))}
                            </div>
                            <Pagination
                                currentPage={pageNumber}
                                totalCount={totalCount}
                                itemsPerPage={TECH_SEARCH_PAGINATION_SIZE}
                                refObject={refFilter}
                                onPageChange={(offset) => {
                                    refreshList(offset);
                                }}
                            />
                        </>
                    )}
                    {state === "idle" && technicians.length === 0 && <p className="text-center text-warning vh-100">No matching talent found.</p>}
                </div>
            </div>
            <Footer />
        </NotificationProvider>
    );
};
